import { ApiBind, CommonSearchParam } from './common-search-param.model';

/**
 * 広告リクエストの検索条件を表すクラス.
 *
 * @class
 * @extends CommonSearchParam
 */
export class AdRequestSearchParam extends CommonSearchParam {
  constructor(
    id?: number,
    name?: string,
    placementName?: string,
    outerPlacementId?: string,
    platformId?: number,
    platformFrameName?: string,
    parameterValue?: string
  ) {
    super();
    this.id = id;
    this.name = name;
    this.placementName = placementName;
    this.outerPlacementId = outerPlacementId;
    this.platformId = platformId;
    this.platformFrameName = platformFrameName;
    this.parameterValue = parameterValue;
  }

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'placement_name' })
  placementName: string;

  @ApiBind({ column: 'outer_placement_id' })
  outerPlacementId: string;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'platform_frame_name' })
  platformFrameName: string;

  @ApiBind({ column: 'parameter_value' })
  parameterValue: string;
}
